import React from "react";
import { RCCButton, RCCGrid, RCCTooltip } from "react-common-components";
import { useTranslation } from "src/context/Translations/context";
import { css } from "styled-components";

const styledButtonExpandOrCompressGroupers = css`
	position: fixed;
	display: flex;
	align-items: center;
    bottom: 1.5rem;
    right: 1.5rem;
    z-index: 2000;
`;

const ButtonExpandGroupers: React.FC = () => {
	const {translate} = useTranslation();
    
	return (
		<>
			<RCCGrid
				styleInline={styledButtonExpandOrCompressGroupers}
			>
				
				<RCCTooltip
					text={translate("Comprimir todos agrupadores")}
					color="grey"
				>
					<RCCButton
						icon={{name: "compress", color: "#FFF", size: 16}}
						color="grey"
						layout="isRounded"
						size="md"
						onClick={() => {
							const groupers = document.querySelectorAll(".rccaccordion-groupers.Mui-expanded");
							const {length} = groupers;

							if(length === 0)
								return;

							for(let i = 0; i < length; i += 1){
								if(groupers[i] === undefined)
									return;
								const accordionNode = groupers[i].firstChild as HTMLDivElement;
								accordionNode.click();
							}
						}}
					/>
				</RCCTooltip>
				
				<RCCTooltip
					text={translate("Expandir próximos 3 agrupadores")}
					color="grey"
				>
					<RCCButton
						icon={{name: "expand", color: "#FFF", size: 16}}
						color="grey"
						layout="isRounded"
						size="md"
						onClick={() => {
							const groupers = document.querySelectorAll(".rccaccordion-groupers:not(.Mui-expanded)");
							const {length} = groupers;

							if(length === 0)
								return;

							for(let i = 0; i < 3; i += 1){
								if(groupers[i] === undefined)
									return;
								const accordionNode = groupers[i].firstChild as HTMLDivElement;
								accordionNode.click();
							}
						}}
					/>
				</RCCTooltip>
			</RCCGrid>
		</>
	);
};

export default ButtonExpandGroupers;
